import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/indicator/importer/indicatorImporterActions';

export default importerReducers(actions);
